import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c2b3f71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-footer mt15" }
const _hoisted_2 = { class: "layout-footer-warp" }
const _hoisted_3 = { class: "mt5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('message.copyright.one5')), 1)
    ])
  ], 512)), [
    [_vShow, _ctx.isDelayFooter]
  ])
}